import "./App.css";
import ErrorPage from "./pages/ErrorPage";
import IndexPage from "./pages/IndexPage";
import Footer from "./components/layout/Footer"
import Navbar from "./components/layout/Navbar"
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProyectPage from "./pages/ProyectPage";
import PrivacyPolicy from "./pages/PrivacyPage";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="*" element={<ErrorPage />} />
        <Route path="/" element={<IndexPage />} />
        <Route path="/motolog/privacy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
